<template>
  <section
    :class="$store.getters['main/getBackgroundTone'](evenOdd)"
    :style="paddingCalculator"
  >
    <div class="small-banner container">
      <div class="filter-layer"></div>
      <div class="small-banner__img">
        <picture>
          <source
            media="(max-width: 767px)"
            :srcset="_.get(randomData, 'images[0].devices.mobile')"
            class="img-absolute br-6"
          />
          <source
            media="(max-width: 1023px)"
            :srcset="_.get(randomData, 'images[0].devices.tablet')"
            class="img-absolute br-6"
          />
          <img
            :src="_.get(randomData, 'images[0].devices.desktop')"
            class="img-absolute br-6"
            alt
          />
        </picture>
      </div>
      <div class="small-banner__content">
        <div class="small-banner__title font-38 text-overflow--line1">
          {{ _.get(randomData, "title2") }}
        </div>
        <div class="small-banner__teaser font-16">
          {{ _.get(randomData, "title") }}
        </div>
        <a
          class="small-banner__button"
          :target="
            _.get(randomData, 'moreLink.url_target') == 1 ? '_blank' : ''
          "
          :href="_.get(randomData, 'moreLink.url')"
        >
          <smart-button
            color="#00A3E0"
            background="#1D2934"
            padding="0 30px"
            :title="_.get(randomData, 'moreLink.title')"
          />
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import SmartButton from "../SmartButton.vue";
import paddingCalculator from "../../mixins/paddingMixin";

export default {
  props: ["contentData", "evenOdd"],
  components: { SmartButton },
  mixins: [paddingCalculator],
  computed: {
    randomData() {
      const min = Math.ceil(0);
      const max = Math.floor(_.size(_.get(this.contentData, "data.list")));
      const randomNumber = Math.floor(Math.random() * (max - min) + min);
      const bannerId = _.get(
        this.contentData,
        `data.list[${randomNumber}].slug`
      );
      if (
        bannerId ==
        _.get(
          this.$store.state.main.current_content,
          "primary.data.list[0].slug"
        )
      ) {
        return randomNumber === max
          ? _.get(this.contentData, `data.list[${randomNumber - 1}]`)
          : _.get(this.contentData, `data.list[${randomNumber + 1}]`);
      } else {
        return _.get(this.contentData, `data.list[${randomNumber}]`);
      }
    }
  }
};
</script>

<style lang="scss">
.small-banner {
  width: 100%;
  height: 377px;
  border-radius: 6px;
  position: relative;
  .filter-layer {
    background: rgba(21, 34, 46, 0.2);
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 1;
  }
  @media (max-width: 1023px) {
    height: 230px;
  }
  &__img {
    position: relative;
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      opacity: 0.8;
    }
  }
  &__content {
    position: absolute;
    left: 55px;
    bottom: 50px;
    right: 20px;
    max-width: 785px;
    z-index: 2;
    @media (max-width: 1366px) {
      left: 80px;
    }
    @media (max-width: 1023px) {
      left: 86px;
    }
    @media (max-width: 767px) {
      left: 50px;
    }
    @media (max-width: 413px) {
      left: 36px;
    }
  }
  &__title {
    color: #ffffff;
    @media (max-width: 767px) {
      margin-top: 10px;
      font-size: 24px;
      -webkit-line-clamp: 2;
      line-height: 33px;
    }
    @media (max-width: 1023px) {
      margin-bottom: 35px;
    }
  }
  &__teaser {
    color: #ffffff;
    margin-top: 18px;
    margin-bottom: 36px;
    line-height: 24px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    @media (max-width: 1023px) {
      display: none;
    }
  }
  &__button {
    .button {
      transition: 0.4s ease;
      span,
      svg path {
        transition: 0.4s ease;
      }
      @media (min-width: 1025px) {
        &:hover {
          background: #00a3e0 !important;
          span {
            color: #1d2934 !important;
          }
          svg path {
            fill: #1d2934 !important;
          }
        }
      }
    }
  }
}
html[lang="ge"] .small-banner .small-banner__title {
  text-transform: uppercase !important;
  -moz-font-feature-settings: "case";
  -webkit-font-feature-settings: "case";
  font-feature-settings: "case" on;
}
</style>
